var globalFunctions = require('./globalFunctions.js');
module.exports = {
  haderHtml: function () {
       let html = '<div class="games-table-header-holder">'+
                      '<div class="games-table-header games-table-title-long"> EVENTS</div> '+
                      '<div class="holder-fix">' +
                        '<div class="games-table-header games-table-tree">'+
                            '<ul>'+
                                '<li>1</li> '+
                                '<li>X</li> '+
                                '<li>2</li>'+
                            '</ul>'+
                        '</div> '+
                        '<div class="games-table-header games-table-tree">'+
                            '<ul>'+
                                '<li>1X</li> '+
                                '<li>12</li> '+
                                '<li>X2</li>'+
                                '</ul>'+
                        '</div> '+
                        '<div class="games-table-header games-table-two">'+
                            '<ul>'+
                                '<li>GG</li> '+
                                '<li>NG</li>'+
                            '</ul>'+
                        '</div>'+
                      '</div>'+
                   '</div>';

        return html;
  },
  gamesHtml: function (index, quotes) {
    let html =  '<div class="games-table-holder" data-popular="'+quotes.ID+'" data-id="'+quotes.ID+'" data-homeTeam="'+quotes.TeamNameHome+'" data-awayTeam="'+quotes.TeamNameAway+'">'+
                    '<div class="games-table games-table-title-long">'+
                        '<div class="game-number">'+index+'.</div> '+quotes.TeamNameHome+' - '+quotes.TeamNameAway+ ' <span class="more-games more-games-span" data-modal="' + quotes.ID + '" > + </span>' +
                    '</div> '+
                    '<div class="holder-fix">' +
                        '<div class="games-table games-table-tree">'+
                            '<ul>'+
                                '<li data-name="winner" data-betType="1" data-betCode="1" class="bet-choose" data-odd="'+quotes.Winner1+'">'+globalFunctions.checkQuotes(quotes.Winner1)+'</li> '+
                                '<li data-name="winner" data-betType="X" data-betCode="0" class="bet-choose" data-odd="'+quotes.WinnerX+'">'+globalFunctions.checkQuotes(quotes.WinnerX)+'</li> '+
                                '<li data-name="winner" data-betType="2" data-betCode="2" class="bet-choose" data-odd="'+quotes.Winner2+'">'+globalFunctions.checkQuotes(quotes.Winner2)+'</li>'+
                            '</ul>'+
                        '</div> '+
                        '<div class="games-table games-table-tree">'+
                            '<ul>'+
                                '<li data-name="DC" data-betType="1X" data-betCode="110" class="bet-choose" data-odd="'+quotes.DC1X+'">'+globalFunctions.checkQuotes(quotes.DC1X)+'</li> '+
                                '<li data-name="DC" data-betType="12" data-betCode="112" class="bet-choose" data-odd="'+quotes.DC12+'">'+globalFunctions.checkQuotes(quotes.DC12)+'</li> '+
                                '<li data-name="DC" data-betType="X1" data-betCode="102" class="bet-choose" data-odd="'+quotes.DCX2+'">'+globalFunctions.checkQuotes(quotes.DCX2)+'</li>'+
                            '</ul>'+
                        '</div> '+
                        '<div class="games-table games-table-two">'+
                            '<ul>'+
                                '<li data-name="GGNG" data-betType="GG" data-betCode="11" class="bet-choose" data-odd="'+quotes.GG+'">'+globalFunctions.checkQuotes(quotes.GG)+'</li> '+
                                '<li data-name="GGNG" data-betType="NG" data-betCode="10" class="bet-choose" data-odd="'+quotes.NG+'">'+globalFunctions.checkQuotes(quotes.NG)+'</li>'+
                            '</ul>'+
                        '</div>'+
                    '</div>'+
               '</div>';
    return html;
  }
};



//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/js/modules/odds/popular.js
// module id = 2003
// module chunks = 4